import styled from 'styled-components';

import { ButtonProps } from './Button';

export const ButtonWrapperStyled = styled.div<
  Pick<
    ButtonProps,
    | 'shouldFitContainer'
    | 'textLeft'
    | 'fontSize'
    | 'marginSize'
    | 'ml'
    | 'mr'
    | 'mb'
    | 'mt'
  >
>`
  display: ${({ shouldFitContainer }) =>
    shouldFitContainer ? 'block' : 'inline-block'};

  ${({ mt }) => mt && 'margin-top: 8px;'}
  ${({ mr, marginSize }) =>
    mr && `margin-right: ${marginSize === 'small' ? 8 : 24}px;`}
  ${({ mb }) => mb && 'margin-bottom: 8px;'}
  ${({ ml, marginSize }) =>
    ml && `margin-left: ${marginSize === 'small' ? 8 : 24}px;`};

  button {
    ${({ textLeft }) => textLeft && 'text-align: left;'};
    ${({ fontSize }) => {
      switch (fontSize) {
        case 'xsmall':
          return 'font-size: 12px;';
        case 'small':
          return 'font-size: 14px;';
        default:
      }
    }};
  }
`;
